import React, { Component, Fragment } from 'react';
import { get, postWithHeaders, postWithHeadersResponse, putWithHeadersResponse } from '../../../../server/actions';
import { _addNotification, _addNotificationError, getSchoolGrades, groupBy } from '../../../../server/util';
const lunchProAlert = {
    alert: {
        marginBottom: '0px'
    },
    acceptSpan: {
        float: 'right'
    },
    acceptBtn: {
        marginTop: '-6px'
    },
    alertText: {
        fontSize: '12px',
        fontStyle: 'italic',
        paddingLeft: '10px'
    }
}

class DirectCertificationAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showList: false,
        }
    }
    componentDidMount = () => {
        this.getDirectCertificationList();
    }
    getDirectCertificationList = () => {
        const { schoolId, districtId, schoolYear } = this.props;
        const url = `/householdApplications/familyDirectCertification/${districtId}/${schoolId}/${schoolYear}?access_token=`;
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ data: data.resp || [] });
        }).catch(
            (error) => {
                console.log('Get School data response', error)
            }
        );
    }
    onClickAccept_Denied = (e, status) => {
        const { self } = this.props;
        const { data } = this.state;
        let headers = {
            'Content-Type': 'application/json'
        };

        if (!(data || []).some(r => r.selected)) {
            _addNotificationError("Please select atleast one student record.", self);
            return false;
        }
        const reqList = (data || []).filter(r => r.selected);
        if (status == 'DENIED') {
            postWithHeaders('/householdApplications/familyDirectCertification/decline?access_token=', JSON.stringify(reqList), headers).then((response) => {
                if (!response.ok) {
                    throw response.text();
                }
                return response.json();
            }).then(resp => {
                _addNotification(resp.statusMessage, self);
                this.getDirectCertificationList();
            }).catch(err => {
                err.then(error => {
                    _addNotificationError(JSON.parse(error).statusMessage, self);
                })
            });

        } else if (status == 'ACCEPT') {
            postWithHeaders('/householdApplications/familyDirectCertification/confirm?access_token=', JSON.stringify(reqList), headers).then((response) => {
                if (!response.ok) {
                    throw response.text();
                }
                return response.json();
            }).then(resp1 => {
                _addNotification(resp1.statusMessage, self);
                this.getDirectCertificationList();
            }).catch(err => {
                err.then(error => {
                    _addNotificationError(JSON.parse(error).statusMessage, self);
                })
            });

        } else {

        }

    }


    render() {
        const { data, showList } = this.state;
        const gradeList = getSchoolGrades(0, false);
        const gradeGroup = groupBy(gradeList, 'value');
        return (
            <Fragment>
                {
                    data.length > 0 && <Fragment> <div className="row">
                        <div className="alert alert-danger alert-dismissable" style={lunchProAlert.alert} role="alert">
                            <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={(e) => this.setState({ showList: false })}>x</button>
                            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                            <span style={lunchProAlert.alertText}>
                                {`${data.length} Direct certification applications found.`}</span>
                            <span style={lunchProAlert.acceptSpan}>
                                <button type="button" className="btn btn-xs btn-primary" style={{ margin: '0 0 9px 0', fontSize: '12px' }} onClick={(e) => {
                                    //this.context.router.history.push('/schoolAdmin/account/show-contact');
                                    this.setState({ showList: true });
                                }}> <span>Show All</span></button></span>
                        </div>
                    </div>
                        {
                            showList && <div className='row'>
                                <div className='col-md-12'>
                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <table className='table table-sm table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th width="10%"></th>
                                                        <th className='text-center'>Student Id</th>
                                                        <th className='text-center'>New Student Name</th>
                                                        <th className='text-center'>New Student Grade</th>
                                                        <th className='text-center'>Parent Email Id</th>
                                                        <th className='text-center'>New Student Eligibility Status</th>
                                                        <th className='text-center'>Existing Student Name</th>
                                                        <th className='text-center'>Existing Student Grade</th>
                                                        <th className='text-center'>Existing Student Eligibility Category</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (data || []).map((row, i) => {
                                                            const newGrade = ((gradeGroup[row.grade] || [])[0] || {}).label;
                                                            const exGrade = ((gradeGroup[row.existingStudentGrade] || [])[0] || {}).label;
                                                            return <tr>
                                                                <td>
                                                                    <input type='checkbox' checked={row.selected} onChange={(e) => row.selected = e.target.checked} />
                                                                </td>
                                                                <td className='text-center'>{`${row.studentId}`}</td>
                                                                <td className='text-center'>{`${row.firstName} ${row.lastName}`}</td>
                                                                <td className='text-center'>{`${newGrade}`}</td>
                                                                <td className='text-center'>{`${row.parentEmail}`}</td>
                                                                <td className='text-center'>{`${row.newStudentEligibilityStatus}`}</td>
                                                                <td className='text-center'>{`${row.existingStudentFirstName} ${row.existingStudentLastName}`}</td>
                                                                <td className='text-center'>{`${exGrade}`}</td>
                                                                <td className='text-center'>{`${row.existingStudentEligibilityCategory}`}</td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={9}>
                                                            <div className='text-right'>
                                                                <button className='btn btn-sm btn-primary' onClick={(e) => {
                                                                    this.setState({ showList: false })
                                                                }}>Cancel</button>{'  '}
                                                                <button className='btn btn-sm btn-primary' onClick={(e) => this.onClickAccept_Denied(e, 'DENIED')} >Denied</button>{'  '}
                                                                <button className='btn btn-sm btn-primary' onClick={(e) => this.onClickAccept_Denied(e, 'ACCEPT')}>Accept</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }

                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default DirectCertificationAlert;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/DirectCertificationAlert.js